













































































































import {Component, Vue, Provide} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import ClientComplaintState from '@/store/modules/clientComplaint/types';
import SingleComplaint from '@/views/Client/Complaints/SingleComplaint.vue';
import SureModal from '@/components/common/SureModal.vue';
import HomeFooter from '@/components/common/home/HomeFooter.vue';
import HomeHeader from '@/components/common/home/HomeHeader.vue';

@Component({
    components: {SingleComplaint, SureModal, HomeFooter, HomeHeader},
})
export default class Complaints extends Vue {

    @Action public getClientComplaints: any;
    @Action public setSureModal: any;
    @Action public updateClientComplaint: any;
    @Action public deleteClientComplaint: any;
    @Action public archiveClientComplaint: any;
    @Action public setSingleClientComplaint: any;
    @Action public unsetSingleClientComplaint: any;

    @State('clientComplaint') public clientComplaintState: ClientComplaintState;

    public async created() {
        await this.getClientComplaints();
    }

    /**
     * Копировать заявление
     * @param complaint
     */
    public copyComplaint(complaint: any) {
        this.setSingleClientComplaint({
            id: 0,
            status: 'draft',
            attachments: [],
            description: complaint.description,
            region: complaint.region,
            district: complaint.district,
            city: complaint.city,
            street: complaint.street,
            house: complaint.house,
            structure: complaint.structure,
            building: complaint.building,
            installation_date: complaint.installation_date,
            bad_date: complaint.bad_date,
            conditions: complaint.conditions,
            wishes: complaint.wishes,
        });
        //this.updateClientComplaint();
    }

    /**
     * Выкинуть окно: "Вы уверены, что хотите удалить?"
     * @param complaint
     */
    public setSureModalComplaint(complaint: any) {
        this.setSureModal({
            title: 'Удалить заявку?',
            text: `Вы уверены, что хотите удалить заявку?`,
            action: async () => {
                this.setSingleClientComplaint(complaint);
                await this.deleteClientComplaint();
                this.unsetSingleClientComplaint();
            },
        });
    }

    /**
     * Выкинуть окно: "Вы уверены, что хотите отправить в архив?"
     * @param complaint
     */
    public setSureModalArchiveComplaint(complaint: any) {
        this.setSureModal({
            title: 'Отправить заявку в архив?',
            text: `Вы уверены, что хотите отправить заявку в архив? Восстановить заявку из архива невозможно`,
            buttonOk: 'Отправить в архив',
            action: async () => {
                this.setSingleClientComplaint(complaint);
                await this.archiveClientComplaint();
                this.unsetSingleClientComplaint();
            },
        });
    }

    /**
     * Выкинуть окно: "Вы уверены, что хотите отправить заявку на рассмотрение?"
     */
    public setSureModalPublicComplaint(complaint: any) {
        this.setSureModal({
            title: 'Отправить заявку на рассмотрение?',
            text: `Вы уверены, что хотите отправить заявку на рассмотрение? Редактировать заявку после отправки будет невозможно!`,
            buttonOk: 'Отправить заявку на рассмотрение',
            action: async () => {
                this.setSingleClientComplaint(complaint);
                this.clientComplaintState.complaint.status = 'public';
                await this.updateClientComplaint();
                this.unsetSingleClientComplaint();
            },
        });
    }

    /**
     * Формируем строку с адресом
     * @param complaint
     */
    public getFullAddress(complaint) {
        const address = [
            complaint.region,
            complaint.district,
            complaint.city,
            complaint.street,
            complaint.house,
            complaint.structure,
            complaint.building,
        ];
        return address.filter((item) => (item && item !== '')).join(', ');
    }

    public isValid(complaint) {
        if ((!complaint.region || complaint.region.toString() === '') &&
            (!complaint.district || complaint.district.toString() === '') &&
            (!complaint.city || complaint.city.toString() === '')) {
            return false;
        }

        if ((!complaint.house || complaint.house.toString() === '') &&
            (!complaint.structure || complaint.structure.toString() === '')) {
            return false;
        }

        if (!complaint.description || complaint.description.toString() === '') {
            return false;
        }

        // Дата установки оборудования
        if (!complaint.installation_date || complaint.installation_date.toString() === '') {
            return false;
        }

        // Дата возникновения неисправности
        if (!complaint.bad_date || complaint.bad_date.toString() === '') {
            return false;
        }

        // Условия возникновения неисправности
        if (!complaint.conditions || complaint.conditions.toString() === '') {
            return false;
        }

        // Пожелания
        if (!complaint.wishes || complaint.wishes.toString() === '') {
            return false;
        }

        if ((!complaint.region || complaint.region === '') ||
            (!complaint.district || complaint.district === '') ||
            (!complaint.city || complaint.city === '')) {
            return false;
        }

        // Длина полей
        if (complaint.region && complaint.region.length > 50) {
            return false;
        }
        if (complaint.district && complaint.district.length > 50) {
            return false;
        }
        if (complaint.city && complaint.city.length > 50) {
            return false;
        }
        if (complaint.street && complaint.street.length > 50) {
            return false;
        }

        if ((!complaint.house || complaint.house === '') &&
            (!complaint.structure || complaint.structure === '')) {
            if (!complaint.house || complaint.house === '') {
                return false;
            }
            if (!complaint.structure || complaint.structure === '') {
                return false;
            }
            return false;
        }

        if (complaint.house && complaint.house.length > 5) {
            return false;
        }
        if (complaint.structure && complaint.structure.length > 5) {
            return false;
        }
        if (complaint.building && complaint.building.length > 5) {
            return false;
        }

        if (!complaint.description || complaint.description === '') {
            return false;
        }
        // Длина сообщения
        if (complaint.description && complaint.description.length > 250) {
            return false;
        }

        // Дата установки оборудования
        if (!complaint.installation_date || complaint.installation_date === '') {
            return false;
        }

        // Дата возникновения неисправности
        if (!complaint.bad_date || complaint.bad_date === '') {
            return false;
        }

        // Условия возникновения неисправности
        if (!complaint.conditions || complaint.conditions === '') {
            return false;
        }
        // Длина сообщения
        if (complaint.conditions && complaint.conditions.length > 250) {
            return false;
        }

        // Пожелания
        if (!complaint.wishes || complaint.wishes === '') {
            return false;
        }
        // Длина сообщения
        if (complaint.wishes && complaint.wishes.length > 250) {
            return false;
        }

        return true;
    }

}
